<template>
    <!-- Div del iframe en absolute para no tapar el input. Label centrado con flex (sin peer-*),
         flota con JS al hacer focus. Si Paycomet destruye el input, el ref queda huérfano
         y el label se congela donde estaba (normalmente arriba porque tuviste focus). -->
    <div class="tw:relative tw:w-full tw:rounded-xl tw:border tw:border-slate-200 tw:bg-white tw:px-3 tw:h-11">
        <div :id="iframeDivId" class="tw:absolute tw:inset-0 tw:z-10" style="padding-top: 5px;"></div>
        <input
            ref="inputRef"
            :paycomet-name="paycometName"
            :paycomet-style="paycometStyle"
            class="tw:relative tw:z-0 tw:w-full tw:h-full tw:text-sm tw:outline-none tw:border-0 tw:bg-transparent tw:text-slate-900"
            @blur="onBlur"
            @input="onInput"
        />
        <span
            v-if="label"
            class="tw:absolute tw:uppercase tw:duration-300 tw:z-20 tw:pointer-events-none tw:tracking-wide tw:origin-left"
            :class="isFloated
                ? 'tw:start-3 tw:top-0 tw:-translate-y-1/2 tw:text-xs tw:font-bold tw:text-blue-500 tw:bg-white tw:px-1'
                : 'tw:start-3 tw:top-1/2 tw:-translate-y-1/2 tw:text-sm tw:font-normal tw:text-slate-400 tw:bg-white tw:px-2'"
        >
            {{ label }}
        </span>
    </div>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue';

    defineProps({
        label: { type: String, default: '' },
        iframeDivId: { type: String, default: '' },
        paycometName: { type: String, default: '' },
        paycometStyle: { type: String, default: '' }
    });

    const inputRef = ref(null);
    const isFloated = ref(false);
    let floatTimer = null;


    // Paycomet reemplaza el input con un iframe apenas carga el SDK.
    // Los eventos @focus/@blur nunca disparan porque el input ya no existe.
    // Solución: flotamos el label automáticamente tras un delay prudencial.
    onMounted(() => {
        floatTimer = setTimeout(() => { isFloated.value = true; }, 600);
    });

    // Solo útiles durante los primeros 600ms antes de que Paycomet reemplace el input.
    const onBlur = () => {
        if (inputRef.value?.value) isFloated.value = true;
    };
    const onInput = () => {
        if (inputRef.value?.value) isFloated.value = true;
    };
    
    onUnmounted(() => {
        if (floatTimer) clearTimeout(floatTimer);
    });
</script>
